import { useState, type FormEvent } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/Button';
import { Callout } from '../components/Callout';
import { Marca } from '../components/Marca';
import { Screen } from '../components/Screen';
import { ApiError } from '../lib/api';
import { firebaseConfigurado } from '../lib/firebase';

export function StaffLoginScreen() {
  const { user, cargando, iniciarSesionConCodigo } = useAuth();
  const location = useLocation();
  const [codigo, setCodigo] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user && !cargando) {
    const destino = (location.state as { from?: string } | null)?.from ?? '/';
    return <Navigate to={destino} replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!firebaseConfigurado) return;
    setError(null);
    setEnviando(true);
    try {
      await iniciarSesionConCodigo(codigo);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'No se pudo entrar. Intenta de nuevo.');
      setEnviando(false);
    }
  }

  return (
    <Screen
      centrado
      acciones={
        <Button
          type="submit"
          form="form-login-staff"
          bloque
          grande
          cargando={enviando}
          disabled={!firebaseConfigurado || codigo.trim().length < 4}
        >
          Entrar
        </Button>
      }
    >
      <div className="space-y-8 rounded-3xl border border-borde bg-white p-10 shadow-sm">
        <Marca className="h-28" />

        <div className="space-y-1.5">
          <h1 className="text-2xl font-semibold text-texto">Código de acceso</h1>
          <p className="text-sm text-texto/60">
            Pide el código a la persona encargada del evento. No necesitas cuenta ni contraseña.
          </p>
        </div>

        <form id="form-login-staff" className="space-y-4" onSubmit={onSubmit} noValidate>
          <input
            type="text"
            inputMode="text"
            autoCapitalize="characters"
            autoCorrect="off"
            autoComplete="off"
            spellCheck={false}
            required
            placeholder="XXXXXXXX"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value.toUpperCase())}
            className="w-full rounded-lg border border-borde bg-white px-3.5 py-3 text-center font-mono text-lg tracking-[0.3em] text-texto focus:border-navy/30 focus:outline-none focus:ring-2 focus:ring-navy/15"
          />
          {error && <Callout tono="error">{error}</Callout>}
        </form>

        <p className="text-center text-sm text-texto/60">
          ¿Tienes cuenta?{' '}
          <Link to="/login" className="font-medium text-navy underline underline-offset-2">
            Inicia sesión
          </Link>
        </p>
      </div>
    </Screen>
  );
}
